import { Exclude, Expose } from "class-transformer";
import { IsBoolean, IsDefined, IsInt, IsNumber } from "class-validator";

import { GField, GInputType, GFloat, GObjectType, GInt } from "../graphql";

@GObjectType("VehicleTypePriceFee")
@GInputType("VehicleTypePriceFeeInput")
@Exclude()
export class VehicleTypePriceFee {
  @GField(() => GInt)
  @IsInt()
  @IsDefined()
  @Expose()
  public vehicleType: number;

  @GField(() => GFloat)
  @IsNumber()
  @IsDefined()
  @Expose()
  public price: number = 0;

  @GField(() => GFloat)
  @IsNumber()
  @IsDefined()
  @Expose()
  public fee: number = 0;

  @IsBoolean()
  @IsDefined()
  @Expose()
  public isManuallyModified: boolean = false;
}
